String.prototype.truncate = function (length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }

  if (this.length > length) {
    return this.substring(0, length - ending.length) + ending;
  }
  return this;
};
